/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API56378Req {
  
  /** 业务编号 */
  bizNo?: string;
  /** 业务类型：1.项目2.业务 */
  bizType?: number;
};



export type API56378Res = {};


// 56378 删除指标

export interface IUsePostAPI56378Return {
  /** 删除指标: 接口请求状态 */
  isAPI56378Loading: boolean;
  /** 删除指标: 接口请求返回数据 */
  dataAPI56378: API56378Res;
  /**  删除指标: 接口数据请求方法 */
  fetchAPI56378Data:  (inputs: API56378Req, config?: YWRequestConfig) => Promise<API56378Res>;
  /** 删除指标: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI56378 = ():IUsePostAPI56378Return => {
  let isMount = true;
  const [isAPI56378Loading, setIsAPI56378Loading] = useState(false);
  const [dataAPI56378, setDataAPI56378] = useState<API56378Res>({} as API56378Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/indicator/delete`;

  const fetchAPI56378Data = async (inputs: API56378Req, config?: YWRequestConfig): Promise<API56378Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API56378Req>) || {}) as API56378Req;
    
  
    if ( isMount ) {
      setIsAPI56378Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API56378Res>(`${basePath}/corp-admin/project/plan/task/indicator/delete`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI56378(res || {} as API56378Res);
        setIsAPI56378Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI56378Loading(false);
      }
      return false as unknown as API56378Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI56378Loading,
    dataAPI56378,
    fetchAPI56378Data,
    requestUrl,
  }
}

